/** Handle default supervision font size */
export enum SupervisionListFontSize {
  SMALL = 13,
  MEDIUM = 16,
  LARGE = 19,
}

/** Handle horizzontal allignment for custom interface */
export enum HAlign {
  LEFT = 0,
  CENTER = 1,
  RIGHT = 2,
}

export enum VAlign {
  UP = 0,
  MIDDLE = 1,
  DOWN = 2,
}

/**
 * Handle Shape Kind
 */
export enum ShapeKind {
  ELLIPSE = 0,
  RECTANGLE = 1,
}

/**
 * Gauge shape type
 */
export enum GaugeShape {
  CIRCULAR = 1,
  CIRCLUAR_HALF = 2,
  CIRCULAR_QUARTER_LEFT = 3,
  CIRCULAR_QUARTER_RIGHT = 4,
  CIRCULAR_THREE_FOURTH = 5,
  CIRCULAR_WIDE = 6,
  DIGITAL = 7,
  LINEAR = 8,
}

/**
 * Handle aggregation type oredering
 */
export enum AggregationType {
  UNKNOWN = 0,
  ONE_COMMAND_TEMPLATE = 1,
  TWO_COMMAND_AND_LABEL_TEMPLATE = 2,
  TWO_OR_MORE_COMMAND_TEMPLATE = 3,
  MULTIPLE_ROWS_TEMPLATE = 4,
  VIRTUAL_ACCESS_TEMPLATE = 5,
}

/**
 * Handle all native BIGStudio component.
 * For more info see db table "GUI_COMPONENTS".
 * It's used code because component are tracked by it
 */
export enum GuiComponent {
  COMMAND_BUTTON = "CommandButton",
  SCENARIO_BUTTON = "ScenarioButton",
  SUPERVISION_BUTTON = "SupervisionButton",
  APPLICATION_BUTTON = "ApplicationButton",
  LINK_BUTTON = "LinkButton",
  LABEL = "Label",
  SHAPE = "Shape",
  VALUE_BAR = "ValueBar",
  VALUE_CHART = "ValueChart",
  ENVIRONMENT_STATUS = "EnvironmentStatus",
  VLC_CAMERA = "VLCCamera",
  IMAGE = "Image",
  GAUGE = "Gauge",
  VIRTUAL_ACCESS = "VirtualAccess",
  CUSTOM_COMPONENT = "CustomComponent",
  SQL_TABLE = "SQLTable"
}

/**
 * Handle generic click action type
 */
export enum ClickActionType {
  NO_ACTIONS = "#NOACTIONS",
  READ = "#READ",
  WRITE = "#WRITE",
  POPUP = "#POPUP",
}

/**
 * Handle custom component functio
 */
export enum CustomComponentFunction {
  NONE = 0,
  FAST_CHECKIN = 1,
  SCHEDULATION = 2,
  WEEKLY_PLANNING = 3,
  READ_CARD = 4,
  SCHEDULATION_EXTENDED = 5,
  ENVIRONMENT_QRCODE = 6,
}

/**
 * Handle custom component open mode
 */
export enum CustomComponentOpenMode {
  INTEGRETED = 0,
  POPUP = 1,
}
